import BaseApiRequest from "./BaseApiRequest";
import { APPLICATION_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetApplicationListRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = APPLICATION_LIST_URL;

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
